import { Box, Typography } from "@mui/material";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import { useLanguage } from "../../../../context/LanguageContext";
import { Colors } from "../../../../styles/theme";
import styles from "./Platform.styles";

const Platform = () => {
  const { translate, translations, selectedLanguage } = useLanguage();
  const isRTL = selectedLanguage === "ar";
  const featureIcons = {
    "financial-management": AccountBalanceOutlinedIcon,
    "sales-and-customers": PointOfSaleOutlinedIcon,
    "purchasing-and-suppliers": ShoppingCartOutlinedIcon,
    "inventory-and-warehouses": Inventory2OutlinedIcon,
    "insight-and-reporting": AnalyticsOutlinedIcon,
    "control-and-security": AdminPanelSettingsOutlinedIcon,
  };
  const platformFeatures = translations?.["platform features"] || [];

  return (
    <Box
      component="section"
      id="platform"
      sx={{
        ...styles.Platform_container,
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <Box sx={styles.Platform_textContainer}>
        <Typography
          variant="subtitle2"
          component="p"
          color={Colors.primary}
          mb={{ xs: 1.25, sm: 2 }}
          sx={{
            fontWeight: 800,
            letterSpacing: 3,
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          {translate("platform eyebrow")}
        </Typography>
        <Typography
          variant="h2"
          sx={{
            color: Colors.navy,
            fontSize: { xs: "2.35rem", md: "4rem" },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.08,
            textAlign: "center",
          }}
          mt={0}
        >
          {translate("platform header")}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color={Colors.text}
          mt={{ xs: 1.5, sm: 2 }}
          sx={{
            fontWeight: 500,
            lineHeight: 1.65,
            textAlign: "center",
          }}
        >
          {translate("platform description")}
        </Typography>
      </Box>
      <Box sx={styles.Platform_grid}>
        {platformFeatures.map((feature) => {
          const FeatureIcon =
            featureIcons[feature.key] || AccountBalanceOutlinedIcon;

          return (
            <Box
              key={feature.key}
              sx={styles.Platform_card}
            >
              <Box sx={styles.Platform_iconContainer}>
                <FeatureIcon sx={styles.Platform_icon} />
              </Box>
              <Typography variant="h5" component="h3" sx={styles.Platform_cardTitle}>
                {feature.title}
              </Typography>
              <Typography variant="body1" sx={styles.Platform_cardDescription}>
                {feature.description}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Platform;
